<div class="textarea-outer {{cssClass}}">
  <div appClick (clicked)="onBearbeiten()" *ngIf="labelPosition === 'top'">
    <h1 *ngIf="titel">{{ titel | translate }}</h1>

    <div class="anmerkungen-container" [class.required]="required && !myValue" [class.anmerkungen-vorhanden]="myValue">
      <span *ngIf="!myValue && !readOnly && placeholder">{{ placeholder | translate }}</span>
      <span *ngIf="myValue" class="preLine">{{ myValue }}</span>
    </div>
  </div>

  <ion-item [lines]="lines" *ngIf="labelPosition === 'left'">
    <ion-label class="ion-text-wrap" position="left">{{ titel }}</ion-label>

    <!-- ReadOnly -->
    <div slot="end" class="input-outer" *ngIf="readOnly">
      <ion-label class="ion-text-wrap">{{ myValue }}</ion-label>
    </div>

    <!-- Bearbeitbar -->
    <div slot="end" class="input-outer" *ngIf="!readOnly" appClick (clicked)="onBearbeiten()">
      <div class="anmerkungen-container" [class.required]="required && !myValue" [class.anmerkungen-vorhanden]="!!myValue">
        <span *ngIf="!myValue" class="preLine keintext">{{ 'Eingeben' | translate }}...</span>
        <span *ngIf="myValue" class="preLine">{{ myValue }}</span>
      </div>
    </div>
  </ion-item>
</div>